import React from 'react'
import './styles.scss'
import '../../styles/index.scss'

export default ({ title, children }) => (
  <div className='clearfix'>
    <h5>{title}</h5>
    {children}
  </div>
)
